import React, { useEffect, useRef } from "react";

const CustomCursor = () => {
  const innerRef = useRef(null);
  const outerRef = useRef(null);

  useEffect(() => {
    const moveCursor = (e) => {
      const { clientX: x, clientY: y } = e;

      if (innerRef.current) {
        innerRef.current.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      }

      if (outerRef.current) {
        outerRef.current.animate(
          [{ transform: `translate3d(${x}px, ${y}px, 0)` }],
          { duration: 150, fill: "forwards", easing: "ease-out" }
        );
      }
    };

    document.addEventListener("mousemove", moveCursor);
    return () => document.removeEventListener("mousemove", moveCursor);
  }, []);

  return (
    <>
      <div
        ref={outerRef}
        className="cursor-outer"
      />
      <div
        ref={innerRef}
        className="cursor-inner"
      />
    </>
  );
};

export default CustomCursor;
